import * as React from 'react'
import { Button, Modal } from 'react-bootstrap'
import HttpActionsService from '../../../Services/HttpActionsService'
import LocalizationStore from '../../../Stores/LocalizationStore'
import DateTimeHelper from '../../../Helpers/DateTimeHelper'
import { observer } from 'mobx-react'
import * as $ from 'jquery'
import { IQuestionnaire } from '../../../Model/Questionnaire'
import { observable } from 'mobx'
import * as _ from 'lodash'

export interface IQuestionnaireContentLinksFormProps {
  className?: string
  questionnaire?: IQuestionnaire
}

@observer
export default class QuestionnaireContentLinksForm
  extends React.Component<IQuestionnaireContentLinksFormProps> {
  @observable
  show = ''

  constructor(props: any) {
    super(props)

    // this.state = {
    //   contentLinkId: 'content-link-id-' + new Date().getTime(),
    //   contentLinkFile: null,
    //   // show: false
    // }
  }

  add(e: any) {
    e.preventDefault()
    const formData = new FormData()
    formData.append('formFiles', e.target.files[0])
    HttpActionsService.getInstance().uploadQuestionnaireFile(this.props.questionnaire!.id, formData)
  }

  delete(e: any, clId: string) {
    if (clId) {
      HttpActionsService.getInstance().deleteQuestionnaireFile(this.props.questionnaire!.id, clId)
    }
    this.show = ''
  }

  edit(e: any, clId: string) {
    let descEl = document.getElementById(clId + 'desc')
    if (descEl) {
      HttpActionsService.getInstance().updateQuestionnaireContentData(clId, descEl['value'])
    }
  }

  showModal(clId: string) {
    this.show = clId
  }

  handleClose(e: any, context: QuestionnaireContentLinksForm) {
    this.show = ''
  }

  linkAnchorCreate(link: string): string {
    if (!link) {
      return ''
    }
    const fileNameRegEx = /(\w+)(\.\w+)+(?!.*(\w+)(\.(\w)+)+)/
    const m: RegExpMatchArray | null = link.match(fileNameRegEx)
    return m && m.length ? m[0] : link
  }

  addFile(e: any) {
    $('#addfilebutton').click()
  }

  render() {
    const self = this
    const ls = LocalizationStore.getInstance()

    return (
      <div className={this.props.className}>

        <div className="container p-0">
          <div className="row">
            <p>{ls.t('contentLinks')}</p>
          </div>

          <div className="row blockContentData">
            {this.props.questionnaire &&
              this.props.questionnaire.contentLinks &&
              this.props.questionnaire.contentLinks.length > 0 ?
              _.orderBy(this.props.questionnaire!.contentLinks, ['createDate'], ['desc'])
                .map(x =>
                  <div className="contentData col-12" key={x.id + ''}>
                    <div className="imageDel">
                      <div className="imageLink">
                        <a
                          target="_blank"
                          className="contentFileName"
                          href={x.link}
                        >
                          <img
                            className={(/\.(gif|jpg|jpeg|tiff|png)$/i).test(x.link) ? '' : 'previewFile'}
                            src={(/\.(gif|jpg|jpeg|tiff|png)$/i).test(x.link)
                              ? x.link
                              : 'images/download_icon_gray.png'}
                          />
                          {this.linkAnchorCreate(x.link)}
                        </a>
                        <div>
                          <span>{ls.t('createDate')}</span>&nbsp;:&nbsp;
                          <span>{DateTimeHelper.formatDateTimeForList(x.createDate)}</span>
                        </div>
                        <div>
                          <span>{ls.t('updateDate')}</span>&nbsp;:&nbsp;
                          <span>{DateTimeHelper.formatDateTimeForList(x['updateDate'])}</span>
                        </div>
                      </div>
                      <Modal
                        show={this.show === x.id}
                        onHide={() => { this.handleClose({}, this) }}
                        animation={false}
                        keyboard={false}
                        backdrop={true}
                      >
                        <div className="formWrapper">
                          <div>
                            <h4>{ls!.t!('Do you really want to delete this content?')}</h4>
                          </div>
                          <Button
                            className="btn-danger"
                            onClick={(e) => self.delete(e, x.id)}
                            title={ls!.t('DeleteTitle')}
                            type="submit"
                          >
                            {ls!.t!('Delete')}
                          </Button>
                          <Button
                            bsStyle="link"
                            onClick={(e) => { return this.handleClose(e, this) }}
                          >
                            {ls!.t!('Back')}
                          </Button>
                        </div>
                      </Modal>
                      <Button
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title={ls!.t!('X')}
                        className="del"
                        onClick={() => this.showModal(x.id)}
                        data-html="true"
                      >
                        {ls!.t!('X')}
                      </Button>
                    </div>

                    <div className="descriptionEdit">
                      <textarea className="description" id={x.id + 'desc'} defaultValue={x.description} />
                      <button
                        className="edit"
                        onClick={(e) => self.edit(e, x.id)}
                      >
                        &#10004;
                      </button>
                    </div>
                  </div>
                ) : <p>{ls.t('no content links yet...')}</p>}
          </div>

          <div className="row">
            <form
              className="w-100"
              onSubmit={e => this.add(e)}
            >
              <label />
              <input id="addfilebutton" type="file" onChange={e => this.add(e)} hidden />
              <Button className="w-100" onClick={(e) => this.addFile(e)}>{ls.t('addFileButton')}</Button>
            </form>
          </div>
        </div>

        {/* <div className={' rjsf'} hidden={!this.props.questionnaire!.id}>
          <fieldset className="field field-array field-array-of-object">

            <div className="blockContentData">

            </div>
          </fieldset>

          <form onSubmit={e => this.add(e)}>
            <label />
            <input id="addfilebutton" type="file" onChange={e => this.add(e)} hidden />
            <Button onClick={(e) => this.addFile(e)}>{ls.t('addFileButton')}</Button>
          </form>
        </div> */}

      </div>

    )
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireContentLinksForm.tsx